import React from "react";
import { nFormatter } from "utils/currencyFormat";

const thuChiHopDongConst = {};
export const ThuChiHopDongCombo = {
  KieuVayDefault: "- Kiểu vay -",
  KieuVayCombo: [
    { value: "0", label: "Tất cả" },
    { value: "3", label: "Cầm đồ" },
    { value: "1", label: "Tín chấp" },
    { value: "2", label: "Trả góp" },
    { value: "4", label: "Nhận vay" },
  ],
  LoaiVayDefault: "- Loại -",
  LoaiVayCombo: [
    { value: "0", label: "Tất cả" },
    { value: "1", label: "Kỳ lãi" },
    { value: "11", label: "Tất toán" },
    { value: "17", label: "Trả bớt gốc" },
    { value: "21", label: "Vay thêm" },
    { value: "2", label: "Chi cho vay" },
    { value: "4", label: "Thu nhận vay" },
    { value: "24", label: "Thu phí khác" },
    { value: "16", label: "Thanh lý tài sản" },
    { value: "56", label: "Sở hữu tài sản" },
  ],
  NhanVienDefault: "- Nhân viên -",
  NhanVienCombo: [
    { value: "-1", label: "Tất cả" },
    { value: "0", label: "Nguyễn Thu Hà" },
    { value: "1", label: "Trịnh Thăng Bình" },
  ],
};

export default thuChiHopDongConst;
